export interface IResponseActivity {
    /** 거래 ID */
    txID: string;
    /** 거래 시간 */
    date: string;
    /** 송신자 */
    from: string;
    /** 수신자 */
    to: string;
    /** 송신자 줄임말 */
    from_short: string;
    /** 수신자 줄임말 */
    to_short: string;
    /** 수량 */
    amount: string;
    /** 원화 금액 */
    krwAmount: string;
    /** 거래 유형 */
    type: string;
    /** 이미지 유형 */
    imgType: string;
    /** 거래 상태 */
    status?: TransactionStatus;
    /** 토큰 타입 */
    coinType: string;
    /** 수수료 */
    fee: string;
    /** 송신자 메모 */ 
    from_memo: string;
    /** 수신자 메모 */
    to_memo: string;
}

export enum TransactionStatus {
    SUCCESS = '성공',
    FAIL = '실패',
}

